import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import * as ella from "@/lib/ellaApi";
import { useStore } from "@/lib/store";
import { useSeo } from "@/lib/seo";
import ProductCard from "@/components/ProductCard";

export default function CategoryPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const { branch, categories } = useStore();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const isAll = id === "all";
  const isPromo = id === "promo";
  const category = !isAll ? categories.find((c) => c.ID === id) : null;

  useSeo({
    title: isPromo ? "Promo" : isAll ? "Semua Kategori" : category?.Name || "Kategori",
    description: `Belanja ${isAll ? "semua produk" : (category?.Name || "produk")} frozen food halal dari Ella Froze. Dikirim same-day dari cabang terdekat.`,
    path: `/category/${id}`,
  });

  useEffect(() => {
    if (!branch) return;
    setLoading(true);
    let active = true;
    setProducts([]);
    ella.getAllProducts({ branchId: branch.ID, categoryId: isAll || isPromo ? "" : id })
      .then((res) => {
        const items = res.status ? res.data || [] : [];
        if (active) setProducts(isPromo ? items.filter((p) => ella.hasDiscount(p.DiscountType) && Number(p.Discount) > 0) : items);
      })
      .catch(() => { if (active) setProducts([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [branch, id, isAll, isPromo]);

  return (
    <div className="pb-8">
      <div style={{ top: "var(--app-header-height, 60px)" }} className="px-4 py-3 flex items-center gap-3 sticky bg-white z-30 border-b border-gray-100">
        <button onClick={() => nav(-1)} data-testid="back-button" className="p-1 -ml-1 hover:bg-gray-100 rounded-full">
          <ChevronLeft className="w-5 h-5" />
        </button>
        <h1 className="font-display text-lg font-bold text-gray-900 truncate">{isPromo ? "Promo" : isAll ? "Semua Kategori" : category?.Name || "Kategori"}</h1>
      </div>
      <div className="p-4">
        {loading ? (
          <div className="grid grid-cols-2 gap-3">
            {Array.from({ length: 6 }).map((_, i) => <div key={i} className="aspect-[3/4] skeleton rounded-2xl" />)}
          </div>
        ) : products.length === 0 ? (
          <div className="py-16 text-center text-gray-400 text-sm">{isPromo ? "Belum ada promo aktif di cabang ini." : "Belum ada produk pada kategori ini."}</div>
        ) : (
          <div className="grid grid-cols-2 gap-3">
            {products.map((p) => <ProductCard key={p.ProductID} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
